import React from 'react';
import Popup from "../Popup";
import FormHeader from "../form/Header";
import JSONPretty from 'react-json-pretty';
import {useTranslation} from "react-i18next";
const JSONPrettyMon = require('react-json-pretty/dist/monikai');

const ViewOrder = ({log, onClose, searchString, ...props}) => {
    const {t} = useTranslation();
    return (
        <Popup size="large" withClose withOverlay onClose={onClose}>
            <FormHeader title={t("Request Body")}></FormHeader>

            <div className="mt-5">
                <JSONPretty
                    id="json-pretty"
                    data={log.requestBody}
                    theme={JSONPrettyMon}
                />
            </div>
        </Popup>
    );
};

export default ViewOrder;
